module.exports = {
      id: "newsletter-usage",
      viewBox: "0 0 26 23.012",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#newsletter",
      toString: function () {
        return this.url;
      }
    }